export function mergeTwoArraysOfObjects (first, second) {
  return [first, second].reduce((a, b) => a.map((c, i) => Object.assign({}, c, b[i])))
}
